import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { ProjectsService } from './projects.service';
import { ProjectsApiService } from './projects-api.service';
import { ToastService } from '../toast/toast.service';

export const projectCompleteGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const projects = inject(ProjectsService);
  const projectsApi = inject(ProjectsApiService);
  const toast = inject(ToastService);
  const router = inject(Router);

  const projectId = route.paramMap.get('id') ?? '';
  const project = projects.getById(projectId);

  if (project?.status === 'Complete') {
    return true;
  }

  if (!project && projectId) {
    return projectsApi.getProject(projectId).pipe(
      map((loaded) => {
        if (loaded.status === 'completed') {
          return true;
        }
        toast.warning('This file is not complete yet and cannot be opened.');
        return router.createUrlTree(['/home']);
      }),
      catchError(() => {
        toast.warning('File not found.');
        return of(router.createUrlTree(['/home']));
      }),
    );
  }

  toast.warning(
    project
      ? 'This file is not complete yet and cannot be opened.'
      : 'File not found.',
  );

  return router.createUrlTree(['/home']);
};
